import {Component} from '@angular/core';
import {TermwebConnectionSettingsComponent} from '../termweb-connection-settings/termweb-connection-settings.component';
import {ScheduledSyncSettingsComponent} from '../scheduled-sync-settings/scheduled-sync-settings.component';
import {LocalizationSettingsComponent} from '../localization-settings/localization-settings.component';

@Component({
  selector: 'pub-settings-panel',
  templateUrl: './settings-panel.component.html',
  styleUrls: ['./settings-panel.component.scss'],
  standalone: true,
  imports: [TermwebConnectionSettingsComponent, ScheduledSyncSettingsComponent, LocalizationSettingsComponent]
})
export class SettingsPanelComponent {

}
